import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/document/getters";
import { actions } from "@/store/modules/document/actions";
import { mutations } from "@/store/modules/document/mutations";
import { IDocumentState, state } from "@/store/modules/document/state";

export const document: Module<IDocumentState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
